/**
 * Composes two event handlers together. The original event handler will be called first.
 * If the original event handler calls `event.preventDefault()`, our event handler will not be called.
 *
 * @example
 * onClick={(event) => composeEventHandlers(props.onClick, (e) => {
 *     // Do something with `e`
 * })(event)}
 */
export function composeEventHandlers<E>(
    originalEventHandler?: (event: E) => void,
    ourEventHandler?: (event: E) => void,
    /**
     * Options:
     * checkForDefaultPrevented - defaults to `true`: Do not execute our event handler if the original event handler calls `event.preventDefault()`
     */
    { checkForDefaultPrevented = true } = {},
) {
    return function handleEvent(event: E) {
        originalEventHandler?.(event);

        if (
            checkForDefaultPrevented === false ||
            !(event as unknown as Event).defaultPrevented
        ) {
            return ourEventHandler?.(event);
        }
    };
}
